define('Components/Vod/js/Vod',['hooks', 'app',
        'Components/Vod/js/views/VodSidedishView',
        'template!Components/Vod/templates/product-line-history',
        'template!Components/Vod/templates/product',
        'template!Components/Vod/templates/category',
        'template!Components/Vod/templates/category-nav-line',
        'template!Components/Vod/templates/vod-block',
        'template!Components/Vod/templates/sidedishes-vod',
    ],
    function (hooks, app,
              VodSidedishView,

              prdoductLineHistoryTemplate,
              productTemplate,
              categoryTemplate,
              categoryNavLIneTemplate,
              vodBlockTemplate,
              sidedisesTemplate
    ) {
        return function () {

            var category, products;

            function getCategory() {
                if (category) return category;
                return category = app.getCategory(app.c('_VOD_CATEGORY_ID_'));
            }

            function getProducts() {
                if (products) return products;
                return products = getCategory().getProducts();
            }

            function requireCrossSelling() {
                var cartProducts = app.getCart().getProducts(),
                    cartProductId = cartProducts.pluck('id_product');
                cartProducts.each(function(p){
                    cartProductId = _.union(cartProductId,p.getAccompagnement().pluck('id_product'));
                });

                var intersection = _.intersection(cartProductId, getProducts().pluck('id_product'));
                return intersection.length == 0;
            }

            hooks.registerHook('hookProductLineTemplate', function (orderProduct, callback) {
                if (typeof orderProduct.getProduct === 'function' ) {
                    var product = orderProduct.getProduct();
                    var id_product = product.id;
                } else if (orderProduct.id) {
                    var id_product = orderProduct.id;
                }
                if (id_product == app.c('_VOD_PRODUCT_ID_')) {
                    callback.call(null, prdoductLineHistoryTemplate);
                }

            });

            hooks.registerHook('vodBlockTemplate', function (options, callback) {
                callback.call(null, vodBlockTemplate);
            });


            hooks.registerHook('getSidedishTemplate', function (templateName, callback) {
                console.log(templateName);
                if(templateName === 'ComponentsVodTemplatesSidedishBlock'){
                    callback.call(null, sidedisesTemplate);
                }
            });

            hooks.registerHook('requireCrossSellingTab', function (options, requireCrossSellingTab) {
                requireCrossSellingTab(requireCrossSelling());
            });

            hooks.registerHook('addCrossSellingTab', function (tabs, addCrossSellingTab) {
                var products = getProducts(),
                    cart = app.getCart();

                // si on a déjà des produits VOD, on affiche pas l'onglet
                if (!requireCrossSelling()) return;


                var p = products.first();
                if (p){
                    var title = app.t('V.O.D. (%s)', 'Vod', p.formatPrice('ttc', true, cart));
                    addCrossSellingTab('vod', title);

                }

            });

            hooks.registerHook('openStepCrossSelling', function (type, openStepCrossSelling) {
                if (type == 'vod') {
                    console.log('openStepCrossSelling VOD');
                    openStepCrossSelling(new VodSidedishView({theme: 'default'}), false, true);
                }
            });

            /*
             hooks.registerHook('addSidedishStep', function (sidedishesSteps, callback) {
             var category = app.getCategory(app.c('_VOD_CATEGORY_ID_')),
             products = category.getProducts(),
             title = app.t('Envie de Vod ?','Vod',category.getName());
             if(app.getCart().getProducts().filter())
             callback(title, products, sidedishTemplate, 'vod');
             });
             */

        }
    });
